import { IconMapHighway16 } from '@cian/ui-kit-design-tokens/icons';
import { UIText2 } from '@cian/ui-kit/typography';

import * as styles from './styles.css';
import { IHighways } from '../../types';

export interface IHighwaysProps {
  highways: IHighways[];
}

export function Highways({ highways }: IHighwaysProps) {
  return (
    <>
      {highways.map(highway => {
        const { id, name, distance } = highway;

        return (
          <div key={id} className={styles['container']}>
            <div className={styles['icon']}>
              <IconMapHighway16 display="block" color="icon-primary-default" />
            </div>
            <span className={styles['name']}>
              <UIText2 display="inline">{name}</UIText2>
            </span>
            {distance && <UIText2 display="inline">{`, ${distance}`}</UIText2>}
          </div>
        );
      })}
    </>
  );
}
